// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ScheduleIntervalDetailsFragmentDoc } from './table/DateCell.generated';
import { ResultingDelayResponseFragmentDoc, ImpactedEntityFragmentDoc, TaskDateEditabilityFragmentDoc, SchedulePhaseProgressDetailsFragmentDoc, TaskFilterOptionsFragmentDoc, InternalUserDetailFragmentDoc, ScheduleSettingDetailsFragmentDoc } from '../../../fragments/circularFragments.generated';
export type ScheduleDetailsFragment = { __typename?: 'Schedule', id: string, stage: Types.Stage, status: Types.ScheduleStatus, isLocked: boolean, parent: { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Development', id: string, teamMembers: Array<{ __typename?: 'DevelopmentTeamMember', id: string, internalUser: { __typename?: 'InternalUser', id: string, name: string, avatar: string } }> } | { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> } | { __typename?: 'ScheduleTemplate', id: string }, market?: { __typename?: 'Market', id: string } | null | undefined, stageDetail: { __typename?: 'StageDetail', code: Types.Stage, name: string }, statusDetail: { __typename?: 'ScheduleStatusDetail', code: Types.ScheduleStatus, name: string }, interval?: { __typename?: 'CalendarInterval', calendarProgress: number, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined, baselineInterval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined, canPublishSchedule: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canCompleteSchedule: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type Schedule_TeamMembers_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Region_Fragment = { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Development_Fragment = { __typename?: 'Development', id: string, teamMembers: Array<{ __typename?: 'DevelopmentTeamMember', id: string, internalUser: { __typename?: 'InternalUser', id: string, name: string, avatar: string } }> };

export type Schedule_TeamMembers_Market_Fragment = { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Community_Fragment = { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Lot_Fragment = { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Structure_Fragment = { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_Unit_Fragment = { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type Schedule_TeamMembers_ScheduleTemplate_Fragment = { __typename?: 'ScheduleTemplate' };

export type Schedule_TeamMembersFragment = Schedule_TeamMembers_StandaloneProject_Fragment | Schedule_TeamMembers_Region_Fragment | Schedule_TeamMembers_Development_Fragment | Schedule_TeamMembers_Market_Fragment | Schedule_TeamMembers_Community_Fragment | Schedule_TeamMembers_Subdivision_Fragment | Schedule_TeamMembers_Lot_Fragment | Schedule_TeamMembers_Structure_Fragment | Schedule_TeamMembers_Unit_Fragment | Schedule_TeamMembers_ScheduleTemplate_Fragment;

export type ScheduleTaskPredecessorDependencyFragment = { __typename?: 'ScheduleTask', id: string, predecessorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, type: Types.TaskDependencyType, lagInDays: number, predecessor: { __typename?: 'ScheduleTask', id: string, name: string } }> };

export type ScheduleTaskSuccessorDependencyFragment = { __typename?: 'ScheduleTask', id: string, successorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, type: Types.TaskDependencyType, lagInDays: number, successor: { __typename?: 'ScheduleTask', id: string, name: string } }> };

export const Schedule_TeamMembersFragmentDoc = gql`
    fragment Schedule_TeamMembers on ScheduleParent {
  ... on Project {
    id
    teamMembers {
      user {
        ...InternalUserDetail
      }
    }
  }
  ... on Development {
    id
    teamMembers {
      id
      internalUser {
        ...InternalUserDetail
      }
    }
  }
}
    ${InternalUserDetailFragmentDoc}`;
export const ScheduleDetailsFragmentDoc = gql`
    fragment ScheduleDetails on Schedule {
  id
  parent {
    ... on HasSchedules {
      id
    }
    ...Schedule_TeamMembers
  }
  market {
    id
  }
  stage
  stageDetail {
    code
    name
  }
  status
  statusDetail {
    code
    name
  }
  interval {
    ...ScheduleIntervalDetails
    calendarProgress
  }
  baselineInterval {
    ...ScheduleIntervalDetails
  }
  scheduleSetting {
    ...ScheduleSettingDetails
  }
  canPublishSchedule {
    allowed
    disabledReasons {
      message
    }
  }
  canCompleteSchedule {
    allowed
    disabledReasons {
      message
    }
  }
  isLocked
}
    ${Schedule_TeamMembersFragmentDoc}
${ScheduleIntervalDetailsFragmentDoc}
${ScheduleSettingDetailsFragmentDoc}`;
export const ScheduleTaskPredecessorDependencyFragmentDoc = gql`
    fragment ScheduleTaskPredecessorDependency on ScheduleTask {
  id
  predecessorDependencies {
    id
    type
    lagInDays
    predecessor {
      id
      name
    }
  }
}
    `;
export const ScheduleTaskSuccessorDependencyFragmentDoc = gql`
    fragment ScheduleTaskSuccessorDependency on ScheduleTask {
  id
  successorDependencies {
    id
    type
    lagInDays
    successor {
      id
      name
    }
  }
}
    `;